module.exports = __webpack_public_path__ + "img/don'tmissyourflight-locked.3cbf82ea.svg";